import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import ListingContainer from "../../containers/listing_container";
import InspectionContainer from "../../containers/inspection_container";
import FilterAttributes from "../../containers/filter_container";
import {INSPECTION_API_URL} from "../../constants/api_routes";
import { duplicateAbortedInspection, editInspectionDateByAgent } from '../../data/inspection_api';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import ViewInspectionDetails from "./view_inspection_details";
import CreateInspection from "./create_inspection";
import UpdateInspection from "./update_inspection";
// import OffersList from "./offers_list"
import CustomerServiceList from "./customer_service_list"
import {Button, Form, Header, Icon, Modal, Popup, Grid, Input, Segment, Message, Label,Card,Dropdown,Divider} from "semantic-ui-react";
import Loader from "../universal/loader";
import StatusUpdateForm from "./change_status";
import AssignClerk from './assign_clerk';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import moment from 'moment-business-days';
import {BASE_URL, CUSTOM_REPORT} from "../../constants/app_routes";
import {handleFileDownload} from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";

class Inspection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            dropdownValue: '',
            selectedInspectionDate: undefined,
            fromDate: undefined,
            toDate: undefined,
            dateFiltered: false,
            inspectionId: undefined,
            currentAssignedUser: undefined,
            isDownloading: false,
            selectiveInspections:false,
            agtChangeDate:undefined,
            agtChangeTime:undefined,
            agtEditNotes:"",
            useDesktopClient:false,
            inspectionsByCompany:undefined,
            isMobile: window.innerWidth < 768,
            mobileFilter: this.props.filterStatus || "",
            original:undefined
        };
    }

    componentWillMount() {
        this.setState({action: 'listing'});
        if (this.props.startDate && this.props.endDate) {
            this.setState({dateFiltered: true});
        }
        if(this.props.inspectionIds){
            this.setState({selectiveInspections:true});
        }
    }

    handleView = (row) => {
        this.setState({action: 'view'});
        if (this.state.dateFiltered) {
            this.props.viewDetails(this.props.inspectionDataByDate.inspections.filter((e) => {
                return e.id === row;
            }));
        }
        else {
            this.props.viewDetails(this.props.inspectionData.inspections.filter((e) => {
                return e.id === row;
            }));
        }
    };

    handleEdit = (row) => {
        this.setState({action: 'update'});
        if (this.state.dateFiltered) {
            this.props.editDetails(this.props.inspectionDataByDate.inspections.filter((e) => {
                return e.id === row;
            }));
        }
        else {
            this.props.editDetails(this.props.inspectionData.inspections.filter((e) => {
                return e.id === row;
            }));
        }
    };
    handleOffer = (inspection_id) => {
        this.setState({
            inspectionId: inspection_id
        });
        this.setState({action: 'offer'});
    };
    
    handleAgentEdit = (inspection_id) => {
        this.setState({
            inspectionId: inspection_id,
            action: 'agent_edit',
            agtChangeDate:moment().add(4,"days").format("DD-MM-YYYY"),
            agtChangeTime:moment().add(4,"days").hour(8).minute(0).format("YYYY-MM-DD HH:mm"),
            anytime:undefined,agtEditNotes:""
        });
    };
    
    handleDuplicate = async(inspection_id) => {
        this.setState({dupeEditLoading:true})
        let formData = new FormData()
        formData.append("inspection_id",inspection_id)
        let response = await duplicateAbortedInspection(formData)
        if (response.success) {
            this.setState({dateFiltered: true,dupeEditLoading:false,dupeLoadError:false});
            if(this.state.fromDate && this.state.toDate){
                this.props.getInspectionsByDate(INSPECTION_API_URL, this.state.fromDate, this.state.toDate);
            } else {                
                this.props.getInspectionsByDate(INSPECTION_API_URL, moment().format("DD-MM-YYYY"), moment().format("DD-MM-YYYY"));  
            }
          }
          else {this.setState({dupeEditLoading:false,dupeLoadError:true})
          setTimeout(()=> {this.setState({dupeLoadError:false})},5000)}
        
    }
    handleEditDate = async (inspection_id) =>{
        this.setState({agtEditLoading:true})
        let formData = new FormData()
        formData.append("inspection_id",inspection_id)
        formData.append("editDate",moment(this.state.agtChangeTime).format("YYYY-MM-DD HH:mm"))
        formData.append("notes",this.state.agtEditNotes)
        formData.append("anytime",this.state.anytime)
        
        let response = await editInspectionDateByAgent(formData)
        if (response.success) {
          this.setState({action:"listing",agtEditLoading:false,dateFiltered: true})
          this.props.getInspectionsByDate(INSPECTION_API_URL, this.state.agtChangeDate, this.state.agtChangeDate);
        }
        else {this.setState({agtEditLoading:false,agtLoadError:true})
        setTimeout(()=> {this.setState({agtLoadError:false})},5000)}
    }
    handleCustomerService = (inspection_id,address,report_id,original) => {
        this.setState({
            inspectionId: inspection_id,action: 'customer_service',CSPropertyAddress:address,reportId:report_id,original:original
        });
    };

    componentWillUnmount() {
        this.props.setFilter(undefined, undefined, undefined , undefined);
    }

    handleDownload = async (id, reportDetail) => {
        if (!this.state.isDownloading ){
            this.setState({isDownloading: true, showDownload: true});
            let URL = BASE_URL + "/report/download/" + id;
            //if(reportDetail['report_pdf_path']){
            //    URL = reportDetail['report_pdf_path'];
            //}
            let fileName = reportDetail['report_filename'];
            await handleFileDownload(URL, fileName,);
            this.setState({isDownloading: false});
            }
    };

    handleReport = (row, status, reportDetail) => {
        const mapStatus = ['pending', 'scheduled', 'confirmed', 'processing', 'submitted', 'completed', 'request_abort', 'aborted', 'request_cancel', 'cancelled'];
        if (reportDetail['custom_report_id']) {
            return (Object.assign(document.createElement('a'), { target: '_blank', href: "/report/custom_report/create/" + reportDetail['custom_report_id']}).click());
        }
        else {
            if ((this.props.userRole === 'clerk' && (mapStatus.indexOf(status) ===  4) || mapStatus.indexOf(status) === 5)  || (this.props.userRole === 'admin' && mapStatus.indexOf(status) === 5)) {
                return(this.handleDownload(reportDetail["report_id"], reportDetail))
            }
            else {
                return ( Object.assign(document.createElement('a'), { target: '_blank', href: "/report/create/" + row}).click())
            }
        }
    };

    exportInspections = async () => {
        this.setState({isDownloading:true,showDownload:true});
        let URL = BASE_URL+"/export/inspections";
        let fileName = "Inspections List.xlsx";
        if(this.state.dateFiltered && this.state.fromDate && this.state.toDate){
            fileName = "Inspections List -"+moment(this.state.fromDate).format("DD-MM-YYYY")+"-"+moment(this.state.toDate).format("DD-MM-YYYY")+" .xlsx";
            URL = BASE_URL+"/export/inspections?start_date="+this.state.fromDate+"&end_date="+this.state.toDate;
        }
        await handleFileDownload(URL,fileName,'application/xlsx');
        this.setState({isDownloading:false});
    };

    handleAssign = (id, user, date, startTime, endTime,companyId) => {
        this.setState({
            inspectionId: id,
            currentAssignedUser: user,
            selectedInspectionDate: date,
            startTime: startTime,
            endTime: endTime,
            companyId:companyId
        });
        this.setState({action: 'assign'});
    };

    calcTimeDict = {
        "08:0018:00":"ANY",
        "08:0017:00":"ANY",
        "08:0012:00":"AM",
        "12:0018:00":"PM"
    }

    calcTime = (startTime,endTime) =>{
        let strTime = this.calcTimeDict[`${startTime}${endTime}`]
        if (strTime != undefined) {
            return strTime
        } else {
            return startTime
        }
    }

    calcSizeFurn =(size, furn) =>{
        let dispSize = size
        if (size == "studio") { dispSize = "ST"}else  {
            dispSize = `${size}B`
        }
            const furnTypes = {
        "unfurnished": "UN",
        "furnished": "F",
        "semifurnished": "PF"
    };

    return `${dispSize}${furnTypes[furn]}`

    }

    handleFilterSelection = () => {
        this.setState({dateFiltered: true});
        if(this.state.fromDate && this.state.toDate){
            this.props.getInspectionsByDate(INSPECTION_API_URL, this.state.fromDate, this.state.toDate);
        }
    };

        getPrevDay = () => {
            const currentDate = this.state.fromDate ? moment(this.state.fromDate, "DD-MM-YYYY") : moment();
            const prevDay = currentDate.subtract(1, 'days').format("DD-MM-YYYY");
        this.setState({
            fromDate: prevDay,
            toDate: prevDay,
            dateFiltered: true
        }, () => {
            this.props.getInspectionsByDate(INSPECTION_API_URL, this.state.fromDate, this.state.toDate);
        });
    };

    getNextDay= () =>{
            const currentDate = this.state.fromDate ? moment(this.state.fromDate, "DD-MM-YYYY") : moment();
            const nextDay = currentDate.add(1, 'days').format("DD-MM-YYYY");
        this.setState({
            fromDate: nextDay,
            toDate: nextDay,
            dateFiltered: true
        }, () => {
            this.props.getInspectionsByDate(INSPECTION_API_URL, this.state.fromDate, this.state.toDate);
        });
    }

    scheduleEmails = async () => {
    let inspections = this.props.inspectionDataByDate.inspections.filter(item => item.status !== "cancelled");

    let companies = [];
    inspections.forEach(inspection => {
        companies.push(inspection.company_name);
    });
    let companiesSet = new Set(companies);
    let inspectionsByCompany = {};
    for (const company of companiesSet) {
        let filteredInspections = inspections
            .filter(item => item.company_name === company)
            .sort((a, b) => {
                let dateA = new Date(a.inspection_time.inspection_date);
                let dateB = new Date(b.inspection_time.inspection_date);
                return dateA - dateB;
            });
            inspectionsByCompany[company] = filteredInspections
        }
         let sortedInspectionsByCompany = Object.fromEntries(
        Object.entries(inspectionsByCompany).sort(([a], [b]) =>
            a.localeCompare(b)
        )
    );
        this.setState({inspectionsByCompany:sortedInspectionsByCompany})
};

openBulkEmail = (inspectionsByCompany) =>{
for (const [company, filteredInspections] of Object.entries(this.state.inspectionsByCompany)) {
    this.openEmail(filteredInspections,company)}
}
copyInspectionTableToClipboardHTML = (filteredInspections = []) => {
    const calcTimeDict = {
        "08:0018:00": "ANYTIME",
        "08:0017:00": "ANYTIME",
        "08:0012:00": "ANYTIME AM",
        "12:0018:00": "ANYTIME PM"
    };

    const furnTypes = {
        "unfurnished": "UN",
        "furnished": "F",
        "semifurnished": "PF"
    };

    const header = [
        "INSPECTION DATE",
        "TIME",
        "COMPANY",
        "PROPERTY ADDRESS",
        "JOB TYPE",
        "SIZE+FURNISHINGS",
        "GET KEYS FROM",
        "RETURN KEYS TO"
    ];

    let html = `
        <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">
            <thead>
                <tr>${header.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
    `;

    filteredInspections.forEach(insp => {
        const startTime = insp.inspection_start_time.slice(11, 16);
        const endTime = insp.inspection_end_time.slice(11, 16);
        const key = startTime + endTime;
        const formattedTime = calcTimeDict[key] || startTime;

        const rowData = [
            moment(insp.inspection_time.inspection_date).format('dddd DD-MM-YYYY'),
            formattedTime,
            insp.company_name,
            insp.property.address,
            insp.inspection_type.toUpperCase(),
            `${insp.property.property_size}B${furnTypes[insp.property.furnishing_type]}`,
            insp.get_keys_from,
            insp.return_keys_to
        ];

        html += `<tr>${rowData.map(data => `<td>${data}</td>`).join('')}</tr>`;
    });

    html += `
            </tbody>
        </table>
    `;

    // Define ClipboardItem here so the linter doesn't throw an error
    try {
        const blob = new Blob([html], { type: 'text/html' });
        const item = new window.ClipboardItem({ "text/html": blob }); // safer
        navigator.clipboard.write([item])
            .catch(err => console.error("Clipboard write failed:", err));
    } catch (e) {
        console.error("Clipboard API not available or failed:", e);
        alert("Copy to clipboard not supported in this browser.");
    }
};


openEmail = (filteredInspections = [],company = "") =>{
        let calcTimeDict = {
        "08:0018:00": "ANYTIME",
        "08:0017:00": "ANYTIME",
        "08:0012:00": "ANYTIME AM",
        "12:0018:00": "ANYTIME PM"
    };
    let furnTypes = { "unfurnished": "UN", "furnished": "F", "semifurnished": "PF" };
        let emailString = "";

        filteredInspections.forEach(insp => {
            let formattedTime = "";
            let startTime = insp.inspection_start_time.slice(11, 16);
            let endTime = insp.inspection_end_time.slice(11, 16);
            let key = startTime + endTime;

            if (calcTimeDict.hasOwnProperty(key)) {
                formattedTime = calcTimeDict[key];
            } else {
                formattedTime = startTime;
            }

            let singleInsString = `${moment(insp.inspection_time.inspection_date).format('dddd DD-MM-YYYY')} | ${formattedTime} | ${insp.company_name} | ${insp.property.address} | ${insp.inspection_type.toUpperCase()} | ${insp.property.property_size}B${furnTypes[insp.property.furnishing_type]} | ${insp.get_keys_from} | ${insp.return_keys_to}`
            // ` ${(insp.user && insp.user.name) || "Unassigned"} | ${insp.status.toUpperCase()}`;
            emailString = emailString + singleInsString;
        });

        let subject = `Inspections Scheduled for ${company} - ${ moment(this.state.fromDate).format('DD-MM-YYYY')} to ${ moment(this.state.toDate).format('DD-MM-YYYY')} - Please check our list and ensure any last minute jobs are booked ASAP to guarantee availability`;

        let body = `Greetings, please see below Inspections Scheduled for the date range of - ${ moment(this.state.fromDate).format('DD-MM-YYYY')} to ${ moment(this.state.toDate).format('DD-MM-YYYY')} - Please check our list and ensure any last minute jobs are booked ASAP to guarantee availability

         INSPECTION DATE | TIME | COMPANY | PROPERTY ADDRESS | JOB TYPE | SIZE+FURNISHINGS | GET KEYS FROM | RETURN KEYS TO
         
         ${emailString}

         Thanks`;

        if (!this.state.useDesktopClient) {
            window.open(`https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(filteredInspections[0].company_email_report)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
        } else {
            window.open(`mailto:${encodeURIComponent(filteredInspections[0].company_email_report)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
        }
}
delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));



    handleStatusChangeDate = (inspectionDate) => {
        var newInspectionDate = moment(inspectionDate, "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY")
        this.setState({dateFiltered: true, fromDate:newInspectionDate,toDate:newInspectionDate});
    };
    disabledHours = () => {
        return [0,1,2,3,4,5,6];
    };
    onStartChange = (value) => {
        if(value) {
            this.setState({agtChangeTime: moment(this.state.agtChangeDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm")});
        }
        else {
            this.setState({agtChangeTime: moment(this.state.agtChangeDate, "DD-MM-YYYY").hour(8).minute(0).format("YYYY-MM-DD HH:mm")});
        }
    };
    render() {
        const timeFormat = 'HH:mm';
        const inspectionStatus = {
            "pending": 'Pending',
            "scheduled": 'Scheduled',
            "confirmed": 'Confirmed',
            "processing": 'Processing',
            "submitted": 'Submitted',
            "completed": 'Completed',
            "request_abort": 'Requested Abort',
            "aborted": 'Aborted',
            "request_cancel": 'Request Cancel',
            "cancelled": 'Cancelled'
        };
        const columns = [{
            Header: 'Date',
            id: 'inspection_time',
            accessor: 'inspection_start_time',
            className: 'date-width',
            headerClassName: 'date-width',
            maxWidth:125,
            filterable: true,
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? moment(row[id], "YYYY-MM-DD HH:mm Z").format("DD:MM:YYYY").toUpperCase().indexOf(filter.value.toUpperCase()) >= 0 : true
            },
            Cell: ({original, value}) => (

                <span>{moment(original['inspection_start_time'], "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY (ddd)")}</span>
            )
        }, {
            Header: 'Time',
            accessor: 'inspection_start_time',
            className: 'partTime-width',
            headerClassName: 'partTime-width',
            maxWidth:70,
            filterable: false,
            Cell: ({original, value}) => (
                <div>
                    <Popup
                        trigger={
                            <span>{this.calcTime(moment(original['inspection_start_time'], "YYYY-MM-DD HH:mm Z").format("HH:mm"),moment(original['inspection_end_time'], "YYYY-MM-DD HH:mm Z").format("HH:mm"))}</span>}
                        content={<div style={{paddingTop: '5px'}}><div>
                                    <Segment><strong>Inventory Check Ins, Check Ins:</strong><br/>The clerk will arrive around 1 hour before the start time to conduct the inventory, the start time is when the clerk will be ready to meet the tenants for check in. The tenants should arrive at start time to meet the clerk</Segment>
                                    <Segment><strong>Inventory Only (No Tenants):</strong><br/>The start time is when the clerk will arrive at the property to carry out the inventory.</Segment>
                                    <Segment><strong>Check Outs:</strong><br />The start time is when the clerk will arrive at property to start the check out, if tenants are present, they should be ready to receive the clerk at the start time</Segment>
                                </div>
                        </div>}
                        position='top center'
                        on='hover'
                        wide
                        header='Inspection Timing'
                        flowing
                        hideOnScroll
                    /></div>
            )
        }, {
            Header: 'Company Name',
            accessor: 'company_name',
            filterable: true,
            className: 'left-aligned',
            maxWidth:"200",
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
            }
        }, {
            Header: 'Address',
            id: 'property',
            className: 'left-aligned',
            accessor: d => d.property['address'],
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
            },
            filterable: true,
            Cell: ({original, value}) => (
                <div>
                    <Popup
                        trigger={<span>{value}</span>}
                        content={<div style={{paddingTop: '5px'}}>
                            <span>{value}</span>
                        </div>}
                        position='top left'
                        on='hover'
                        wide
                        header='Inspection Address'
                        hideOnScroll
                    /></div>
            )
        }, {
            Header: 'Job type',
            accessor: 'inspection_type',
            id: 'inspection_type',
            className: 'formatcase mini-width',
            headerClassName: 'mini-width dropdown-overlay',
            maxWidth:75,
            filterable: true,
            filterMethod: (filter, row) => {
                if (filter.value === "ci") {
                    return row[filter.id] === 'ci';
                }
                if (filter.value === "co") {
                    return row[filter.id] === 'co';
                }
                if (filter.value === "inv") {
                    return row[filter.id] === 'inv';
                }
                if (filter.value === "inv/ci") {
                    return row[filter.id] === 'inv/ci';
                }
                if (filter.value === "pv") {
                    return row[filter.id] === 'pv';
                }
                if (filter.value === "rev") {
                    return row[filter.id] === 'rev';
                }
                if (filter.value === "cln") {
                    return row[filter.id] === 'cln';
                }
                if (filter.value === "sng") {
                    return row[filter.id] === 'sng';
                }
                return true;
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : "all"}
                >
                    <option value="true">Show all</option>
                    <option value="ci">CI</option>
                    <option value="co">CO</option>
                    <option value="inv">INV</option>
                    <option value="inv/ci">INV/CI</option>
                    <option value="pv">PV</option>
                    <option value="rev">REV</option>
                    <option value="cln">CLN</option>
                    <option value="sng">SNG</option>
                </select>
        }, {
            Header: 'Size',
            headerClassName: 'micro-width',
            className: 'micro-width format-capitalize',
            accessor: 'property_size',
            maxWidth: 60,
            filterable: true
        }, {
            Header: 'Property Type',
            id: 'proptype',
            accessor: d => d['furnishing_type'] === 'semifurnished' ? "Part-Furnished" : d['furnishing_type'],
            className: 'format-capitalize',
            filterable: true,
            maxWidth:110,
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : ""}
                >
                    <option value="">Show all</option>
                    <option value="furnished">Furnished</option>
                    <option value="Part-Furnished">Part-Funished</option>
                    <option value="unfurnished">Un-Furnished</option>
                </select>,
        }, {
            Header: this.props.userRole === "clerk" ? "Report Due Date":"Assigned To",
            id: 'user',
            maxWidth: 150,
            accessor: d => d.user ? d.user['name'] : "unassigned",
            Cell: ({original, value}) => (
                this.props.userRole === "clerk" ? <span>{moment(original['inspection_start_time'], "YYYY-MM-DD HH:mm Z").businessAdd(original['priority_tat']?1:2).format("DD-MM-YYYY")}</span> :<div
                    onClick={(e) => {
                        this.props.userRole === 'admin' && this.handleAssign(original.id, original.user, original['inspection_time']['inspection_date'], original['inspection_start_time'], original['inspection_end_time'],original["company_id"])
                    }}>
                    {original.user ?
                        <span className={this.props.userRole === 'admin' ? "assign-user" : ""}>{value}</span> :
                        <span className={this.props.userRole === 'admin' ? "status-red assign-user" : "status-red"}>Un Assigned</span>}
                </div>
            ),
            filterable: true
        }, {
            Header: 'Ref No',
            accessor: 'reference_id',
            filterable: true,
            className: 'left-aligned',
            maxWidth:200,
            Cell: ({original, value}) => (

                <div>
                    {(original['tenant_name'] && original['tenant_name'].includes('?')) || (original['tenant_contact'] && original['tenant_contact'].includes('?')) || (original['get_keys_from'] && original['get_keys_from'].includes('?')) || (original['return_keys_to'] && original['return_keys_to'].includes('?')) || (original['notes'] && original['notes'].includes('?')) || (original['conclusion_notes'] && original['conclusion_notes'].includes('?')) ?
                        <Popup
                            trigger={<div className="format-bold" style={{color: '#ff6200'}}>
                                <span>{(original['conclusion_notes'] && original['conclusion_notes'].includes('(CS)')) && <Icon name="flag" color="blue" size="small" />}</span>
                                <span>{((original['get_keys_from'] && original['get_keys_from'].includes('?')) || (original['return_keys_to'] && original['return_keys_to'].includes('?'))) && <Icon color="olive" name="key" size="small" />}</span>
                                <span>{((original['tenant_name'] && original['tenant_name'].includes('?')) || (original['tenant_contact'] && original['tenant_contact'].includes('?'))) && <Icon color="yellow" name="user" size="small" />}</span>
                                <span>{(original['notes'] && original['notes'].includes('?')) && <Icon color="orange" name="list" size="small" />}</span>
                                <span>{(original['notes'] && original['notes'].includes('INSPECTION DATE CHANGE')) && <Icon  color="red" name="calendar" size="small" />}</span>
                                <span>{(original['conclusion_notes'] && original['conclusion_notes'].includes('?')) && <Icon color="orange" name="hourglass end" size="small" />}</span>
                                <span>{value ? value.toUpperCase() : (original['report_type'] + "-" + original['id']).toUpperCase()}</span>
                            </div>}
                            content={<div className="pad-top">
                                <ul style={{listStyleType:"none"}}>
                                    {((original['tenant_name'] && original['tenant_name'].includes('?')) || (original['tenant_contact'] && original['tenant_contact'].includes('?'))) &&
                                    <li><Icon color="yellow" name="user" size="small" />
                                        Tenant details.
                                    </li>
                                    }
                                    {((original['get_keys_from'] && original['get_keys_from'].includes('?')) || (original['return_keys_to'] && original['return_keys_to'].includes('?'))) &&
                                    <li> <Icon color="olive" name="key" size="small" />
                                        Key collection and/or return.
                                    </li>
                                    }
                                    {(original['notes'] && original['notes'].includes('?')) && <li> <Icon color="orange" name="list" size="small" />
                                        Inspection notes contain an actionable point.
                                    </li>
                                    }
                                      {(original['notes'] && original['notes'].includes('INSPECTION DATE CHANGE')) && <li><Icon  color="red" name="calendar" size="small" />
                                        Inspection Date Change requested by agent.
                                    </li>
                                    }
                                    {(original['conclusion_notes'] && original['conclusion_notes'].includes('?')) &&
                                    <li><Icon color="orange" name="hourglass end" size="small" />
                                        Conclusion notes contain an actionable point.
                                    </li>
                                    }
                                    {(original['conclusion_notes'] && original['conclusion_notes'].includes('(CS)')) &&
                                        <li>
                                        {this.props.userRole === "admin" ? original['conclusion_notes'] : "This inspection has been flagged for customer service"}
                                        </li>
                                    }
                                </ul>
                            </div>}
                            position='top left'
                            on='hover'
                            wide
                            header='The following points need confirmation/action:'
                            flowing
                            hideOnScroll
                        /> : <span> {((original['conclusion_notes'] && original['conclusion_notes'].includes('(CS)'))|| (original['notes'] && original['notes'].includes('INSPECTION DATE CHANGE'))) ? <Popup
                            trigger={<div className="format-bold" style={{ color: '#2185d0' }}>
                                {(original['notes'] && original['notes'].includes('INSPECTION DATE CHANGE')) && <span><Icon name="calendar" color="red" size="small" /></span>}
                                  {(original['conclusion_notes'] && original['conclusion_notes'].includes('(CS)')) && <span><Icon name="flag" color="blue" size="small" /></span>}
                                <span>{value ? value.toUpperCase() : (original['report_type'] + "-" + original['id']).toUpperCase()}</span>
                            </div>}
                            content={<div className="pad-top">
                                <ul>
                                    {(original['conclusion_notes'] && original['conclusion_notes'].includes('(CS)')) &&
                                        <li>
                                           {this.props.userRole === "admin" ? original['conclusion_notes'] : "This inspection has been flagged for customer service"}
                                        </li>
                                    }
                                    {(original['notes'] && original['notes'].includes('INSPECTION DATE CHANGE')) && <li>
                                        Inspection Date Change requested by agent
                                    </li>
                                    }
                                </ul>
                            </div>}
                            position='top left'
                            on='hover'
                            wide
                            hideOnScroll
                        /> : <span>{value ? value.toUpperCase() : (original['report_type'] + "-" + original['id']).toUpperCase()}</span>
                        } </span>}
                </div>
            ),
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                const fieldValue = row['_original']['report_type'] + "-" + row['_original']['id'];
                const inspectionId = "-" + row['_original']['id'];
                return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) || fieldValue.toUpperCase().startsWith(filter.value.toUpperCase()) || inspectionId.startsWith(filter.value.toUpperCase()) : true
            },
        }, {
            Header: 'Status',
            id: 'status',
            accessor: 'status',
            className: 'format-capitalize',
            maxWidth:125,
            Cell: ({original, value}) => (
                <div>
                    {this.props.userRole !== 'admin' && (Object.keys(inspectionStatus).indexOf(value) === 4 || Object.keys(inspectionStatus).indexOf(value) === 5 || this.props.userRole === 'agent') ?
                        <Button size='mini' fluid><span className='format-capitalize'> {inspectionStatus[value]}</span></Button> :<StatusUpdateForm  currentStatus={original["status"]} statusDateChange= {() => {this.handleStatusChangeDate(original['inspection_start_time'])}} inspectionDate={original['inspection_start_time']} inspectionId={original.id} userRole={this.props.userRole}
                                                       startDate={this.state.fromDate} endDate={this.state.toDate}/>}
                </div>
            ),
            filterMethod: (filter, row) => {
                if (filter.value === "due") {
                    if ((moment(row.inspection_time,"YYYY-MM-DD").businessDiff( moment()) >2)&& moment(row.inspection_time,"YYYY-MM-DD") < moment()) {
                        return (row[filter.id] === 'scheduled' || row[filter.id] === 'confirmed' || row[filter.id] === "processing")
                    }
                }
                else if (filter.value !== "") { return row[filter.id] === filter.value}
                else return true
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : ""}
                >
                    <option value="">Show all</option>
                    <option value="pending">Pending</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="confirmed">Confirmed</option>
                    <option value="processing">Processing</option>
                    <option value="submitted">Submitted</option>
                    <option value="completed">Completed</option>
                    {/*<option value="request_abort">Req. Abort</option>*/}
                    <option value="aborted">Aborted</option>
                    <option value="due">Due</option>
                    {/*<option value="request_cancel">Req. Cancel</option>*/}
                    <option value="cancelled">Cancelled</option>
                </select>,

            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            headerClassName: 'table-actions',
            className: 'table-actions',
            accessor: 'id',
            sortable:false,
            Cell: ({original, value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                    {this.props.userRole === 'admin' && <Button basic compact icon primary size='mini' onClick={() => {
                        this.handleEdit(value)
                    }}><Icon
                        name='edit'/>Edit</Button>}
                       {this.props.userRole === 'agent' &&
                       <Button disabled={moment(original['inspection_start_time'], "YYYY-MM-DD HH:mm Z").diff(moment(),"days")<3}onClick={()=>{   this.handleAgentEdit(original.id)}} basic compact icon primary size='mini'><Icon
                        name='edit'/>Edit</Button>}
                        {this.props.userRole === 'admin' && original['status'] === 'aborted' && <Popup on={"click"}trigger={<Button basic compact icon primary size='mini' ><Icon
                        name='edit'/>Duplicate</Button>}><Message><Message.Header>Duplicate this booking?</Message.Header><Message.Content style={{textAlign:"center"}}>Will create new booking with same details and date, in pending status<Button disabled={this.state.dupeEditLoading} loading={this.state.dupeEditLoading}onClick={()=>{this.handleDuplicate(original.id)}}positive>Confirm</Button><br/>{this.state.dupeLoadError && <span><strong>Error while duplicating</strong></span> }</Message.Content></Message></Popup>}
                    {this.props.userRole !== 'agent' ? <Button basic compact icon color='orange' size='mini'
                            disabled={!(original['user'] && original['user']['name'])}
                            as="a"
                            target="_blank"
                            onClick={() => {this.handleReport(original['report_id'], original['status'], original)} }
                            > {(original.conclusion_notes||"").includes("(DNS)") || (original.notes || "").includes("(DNS)") ?<span><Icon
                        name='dont'/>DNS</span> : <span>Report<Icon name="arrow right"/></span>  } </Button>:<Button basic compact icon color='orange' size='mini'
                                                    disabled={!(original['user'] && original['user']['name'] && original['status'] === 'completed')}
                                                    as="a"
                                                    target="_blank"
                                                   onClick={() => {this.handleReport(original['report_id'], original['status'], original)} }
                            > Report <Icon
                            name='arrow right'/></Button>
                        }
                    <Button basic compact icon size='mini' color="brown" onClick={() => { this.handleCustomerService(original.id, original.property['address'],original.report_id,original) }}><Icon name='chat' color="brown" />CS {original.CSCount? original.CSCount:null}</Button>    
                        {/* {this.props.userRole === 'admin' && (original.status === "scheduled" || original.status === "pending") && <Button basic compact icon size='mini' color="grey" onClick={() => {
                            this.handleOffer(original.id)
                        }}><Icon
                                name='list' color="grey" />Offers</Button>} */}
                </div>
            )
        }];
        return (<div className="listing-container">
                <Grid stackable >
                    <Grid.Row>
                        <Grid.Column width={2}>
                        <Header size='large' textAlign='left'>Inspections</Header>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <div style={{marginLeft: '1%'}}>
                                   {this.props.userRole !== "clerk" &&
                                <Popup trigger={<Button as="a" href={"/inspection/create"} primary icon > <Icon name='plus'/>
                                </Button>}
                                content={<span>Add New Inspection</span>}
                                />}
                            <Popup trigger={<Button icon><Icon name="download"></Icon></Button> }
                                                                     content={<div className="pad-top">{this.state.dateFiltered?<p>Inspections from {moment(this.state.fromDate,"DD-MM-YYYY").format("DD-MM-YYYY")} to {moment(this.state.toDate,"DD-MM-YYYY").format("DD-MM-YYYY")}</p>:<p>Todays {moment().format("DD-MM-YYYY")} Inspections</p>}<Button content="Export Inspections" icon="download" labelPosition="left" onClick={this.exportInspections}/></div>}
                                                                     header="Export"
                                                                     on='click'
                                                                     position="bottom center"
                                                                     flowing
                                                                     hideOnScroll
                                                                     wide />
{this.props.userRole == "admin" && <Popup position='bottom left' wide="very" trigger={<Button onClick={()=>{this.scheduleEmails()}}disabled={!this.state.fromDate || !this.state.toDate || !(this.props.inspectionDataByDate && this.props.inspectionDataByDate.inspections && this.props.inspectionDataByDate.inspections.length > 0)} icon><Icon name="mail"></Icon></Button> }
                                                                     content={<div style={{maxHeight:"400px",overflowY:"auto"}}className="pad-top"><p>Send schedule email to clients using inspections currently displayed in table</p> <p>Make sure you don't change the date in the date selector after clicking "get inspections" button as this is what will be the date range used in the email text and if changed might not match the inspections on the table.</p><div style={{textAlign:"center"}}><h4>Email Method:</h4><Button.Group><Button compact content="Desktop Email Client" primary={this.state.useDesktopClient} icon="mail" labelPosition="left" onClick={()=>this.setState({useDesktopClient:true})}/><Button  compact content="Office 365" icon="globe"primary={!this.state.useDesktopClient} labelPosition="left" onClick={()=>this.setState({useDesktopClient:false})}/></Button.Group><hr/>
                                                                     {this.state.inspectionsByCompany && <Button onClick={()=>{this.openBulkEmail()}} icon> <Icon name="mail"></Icon>Email All</Button>}
                                                                     <hr/>
                                                                     {this.state.inspectionsByCompany && Object.entries(this.state.inspectionsByCompany).map(([company, filteredInspections]) => {return <div key={company}style={{margin:"10px"}}>
                                                                        <Button.Group   compact>
                                                                            <Label basic color="grey" >{company}</Label>
                                                                            <Button onClick={()=>{this.openEmail(filteredInspections,company)}} basic color="blue" >Open Email</Button>
                                                                            <Button onClick={()=>{this.copyInspectionTableToClipboardHTML(filteredInspections)}}>Copy Table</Button></Button.Group>
                                                                            </div>})}
                                                                     </div></div>}
                                                                     header="Schedule Emails" on='click'  />}                                

                            {this.props.userRole ==="admin" && <Popup
                            trigger={<Button icon onClick={()=>{this.setState({action:"assign_viewonly"})}}><Icon name="globe"></Icon></Button> }
                            content={<span>View Timeline</span>}
                            />  }   
                            <Popup
                            trigger={<Button icon onClick={()=>{this.setState({isMobile:!this.state.isMobile})}}><Icon name="eye"></Icon></Button> }
                            content={<span>Toggle Mobile View</span>}
                            />                         
                        <Input 
                        onKeyPress={
                            (e)=>{
                                if(e.key==="Enter") {
                                    this.props.getInspectionsByAddress(INSPECTION_API_URL,this.state.searchAddress.replace(",",""));this.setState({dateFiltered:true})
                                }
                            }
                    } 
                        onChange={e=>{this.setState({searchAddress: e.target.value})}} placeholder="Search by address"label={<Button disabled={(this.state.searchAddress || "").length < 4} onClick={()=>{this.props.getInspectionsByAddress(INSPECTION_API_URL,this.state.searchAddress.replace(",",""));this.setState({dateFiltered:true})}}content='Search' />} labelPosition='right'/>                            
                            </div></Grid.Column>
                        <Grid.Column width={8} className="right-aligned">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                            {this.state.dateFiltered ?
                            <div className="center-aligned" style={{lineHeight: '2.7em'}}><span>Inspections from :</span><span
                                className="format-bold">{moment(this.state.fromDate ? this.state.fromDate : moment().format("DD-MM-YYYY"),"DD-MM-YYYY").format("DD-MM-YYYY").toString()}</span><span> to </span><span
                                className="format-bold">{moment(this.state.toDate ? this.state.toDate : moment().format("DD-MM-YYYY"),"DD-MM-YYYY").format("DD-MM-YYYY").toString()}</span>
                            </div>:!this.state.selectiveInspections ? <div className="center-aligned" style={{lineHeight: '2.7em'}}> <span>Inspections for Today </span><span
                                    className="format-bold">({moment().format("DD-MM-YYYY").toString()})</span></div> : <div><span>Inspections of a particular property</span>
                                </div>}
                                <Button.Group  style={{marginLeft:"10px"}}>
                                   <Popup
                                    trigger={<Button disabled={this.props.isListFetching && !this.state.selectiveInspections} onClick={()=>{this.getPrevDay()}}icon='left arrow' />}
                                    content='Previous Day'  position='top center'size='tiny'
                                  />
                                                           <Popup
                                trigger={<Button content='Date'/>}
                                content={<div>
                                    <div><Header
                                        content="Filter Inspection By Date"/><Form><span><b>From: </b><DayPickerInput
                                        placeholder="From"
                                        dayPickerProps={{
                                            todayButton: 'Today',
                                            firstDayOfWeek : 1,
                                        }}
                                        format="DD-MM-YYYY"
                                        value={this.state.fromDate?this.state.fromDate:moment().format("DD-MM-YYYY")}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        onDayChange={day => {day ? this.setState({fromDate: day,toDate:day}): this.setState({fromDate:undefined})}}/></span>
                                        <span><b>To: </b><DayPickerInput
                                            placeholder="To"
                                            format="DD-MM-YYYY"
                                            formatDate={formatDate}
                                            value={this.state.toDate}
                                            parseDate={parseDate}
                                            dayPickerProps={{
                                                disabledDays: {before: this.state.fromDate},
                                                todayButton: 'Today',
                                                firstDayOfWeek : 1,
                                            }}
                                            onDayChange={day => {day ?this.setState({toDate: day}): this.setState({endDate:undefined}) }}/></span></Form></div>
                                    <br/>
                                    <div style={{width: '100%'}} className="right-aligned"><Button
                                        content="Get Inspections" primary
                                        onClick={() => this.handleFilterSelection()}/></div>
                                </div>}
                                on='click'
                                position="bottom left"
                                flowing
                                hideOnScroll
                            wide
                            />
                                  <Popup
                                    trigger={<Button disabled={this.props.isListFetching && !this.state.selectiveInspections} onClick={()=>{this.getNextDay()}} icon='right arrow' />}
                                    content='Next Day'
                                    position='top center'
                                    size='tiny'
                                  />
</Button.Group>

                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <div className="pad-top pad-bottom center-aligned">
                    {this.props.isFetching && this.state.selectiveInspections && <Loader/>}
                    {(!this.state.dateFiltered && this.props.isFetching) ? <Loader customText="Loading inspection data, sit tight!" marginBottom="1000px" contain={true} /> : (this.props.isListFetching && !this.state.selectiveInspections) ? <Loader customText={"Loading inspection data, sit tight!"} marginBottom="1000px" contain={true}/> : null}
                   {this.props.userRole === "clerk" && (() => {
                    var visits = !this.state.dateFiltered
                        ? (this.props.inspectionData && this.props.inspectionData.visits) || []
                        : (this.props.inspectionDataByDate &&
                            this.props.inspectionDataByDate.visits) ||
                        [];

                    var today = new Date().setHours(0, 0, 0, 0);

                    var filteredVisits = visits
                            .filter(function (visit) {
                                var visitDate = new Date(visit.visit_date).setHours(0, 0, 0, 0);
                                return (
                                    visitDate >= today &&
                                    visit.status.toLowerCase() !== "cancelled"
                                );
                        })
                        .sort(function (a, b) {
                        return new Date(a.visit_date) - new Date(b.visit_date);
                        });
                    if (filteredVisits.length === 0) {
                        return null;
                    }

                    return (
                        <Message negative>
                        <Message.Header>
                            ATTENTION: The following PVs are also booked for the selected date range.
                        </Message.Header>
                        Please ensure these are not missed, hover/tap PV for full details.
                           {filteredVisits.map((visit, idx) => (
                        <Popup
                            key={idx}
                            position="right center"
                            wide
                            trigger={
                            <Button compact style={{ display: "block", marginBottom: "5px" }}>
                                {moment(visit.visit_date).format("DD-MM-YYYY") +
                                " | " +
                                visit.visit_time +
                                " | " +
                                visit.company +
                                " | " +
                                visit.address +
                                " | " +
                                visit.status.toUpperCase()}{" "}
                            </Button>
                            }
                            content={
                            <div>
                                <p><strong>Date:</strong> {moment(visit.visit_date).format("DD-MM-YYYY")}</p>
                                <p><strong>Time:</strong> {visit.visit_time}</p>
                                <p><strong>Company:</strong> {visit.company}</p>
                                <p><strong>Address:</strong> {visit.address}</p>
                                <p><strong>Status:</strong> {visit.status.toUpperCase()}</p>
                                <p><strong>Notes:</strong> {visit.notes}</p>
                                <p><strong>Tenant Contact:</strong> {visit.tenant_contact}</p>
                                <p><strong>Tenant Name / Email:</strong> {visit.tenant_name} | {visit.tenant_email}</p>
                            </div>
                            }
                        />
                        ))}
                        </Message>
                    );
                    })()}
                    {(this.props.inspectionData || this.props.inspectionDataByDate) && <React.Fragment>
                   {this.state.isMobile && <Segment>
                      <div style={{ textAlign: 'center', margin: '1rem 0' }}>
                        <label style={{ fontWeight: 'bold', marginRight: '0.5rem' }}>Filter By Status:</label>
                        <Dropdown
                            placeholder="Filter by status"
                            selection
                            clearable
                            value={this.state.mobileFilter}
                            options={[
                            { key: 'all', text: 'All', value: '' },
                            { key: 'scheduled', text: 'Scheduled', value: 'scheduled' },
                            { key: 'confirmed', text: 'Confirmed', value: 'confirmed' },
                            { key: 'processing', text: 'Processing', value: 'processing' },
                            { key: 'submitted', text: 'Submitted', value: 'submitted' },
                            { key: 'completed', text: 'Completed', value: 'completed' },
                            ]}
                            onChange={(e, { value }) => this.setState({ mobileFilter: value })}
                        />
                        </div>
                    <Divider/>
                    <Card.Group centered>
                    {(!this.state.dateFiltered ? this.props.inspectionData.inspections|| [] : this.props.inspectionDataByDate.inspections||[]).sort((a, b) => new Date(a.inspection_start_time) - new Date(b.inspection_start_time)).filter(insp => 
      !this.state.mobileFilter || insp.status === this.state.mobileFilter
    ).map(insp =>{return <Card>
      <Card.Content>
        <Card.Header>{insp.property.address}</Card.Header>
        <Card.Meta> <div class="schedule-card"style={{textAlign:"left"}}><Icon name="calendar"></Icon>DATE:{ <Button compact circular basic >{moment(insp['inspection_start_time'], "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY (ddd)")}</Button>
        } <br/>
                           <Icon name="clock"></Icon> TIME:<Button compact circular basic > {this.calcTime(moment(insp['inspection_start_time'], "YYYY-MM-DD HH:mm Z").format("HH:mm"),moment(insp['inspection_end_time'], "YYYY-MM-DD HH:mm Z").format("HH:mm"))}</Button> <br/>
                   <Icon name="settings"></Icon>JOB TYPE:<Button compact circular basic > {insp.inspection_type.toUpperCase()}</Button><br/>
                   <Icon name="home"></Icon>SIZE / FURN:<Button compact circular basic > {
                   this.calcSizeFurn(insp.property_size,insp.furnishing_type)}
                   </Button><br/>
                   <Icon name="key"></Icon> KEYS FROM:<Button compact circular basic > {insp.get_keys_from} </Button><br/>
                    <Icon name="key"></Icon>KEYS TO:<Button compact circular basic > {insp.return_keys_to} </Button> <br/>
                    <Icon name="at"></Icon>COMPANY:<Button compact circular basic > {insp.company_name} </Button> <br/>
                    <Icon name="hashtag"></Icon> REF:<Button compact circular basic > {insp.reference_id} </Button><br/>
                    <Icon name="list"></Icon>NOTES:                    <Popup trigger={<Button compact circular basic > {insp.notes && insp.notes.trim() ? "Tap to see ":"None"}</Button>}
                    content={insp.notes}/><br/>
                    <div>   <Icon name="info"/>STATUS
                    {this.props.userRole !== 'admin' && (Object.keys(inspectionStatus).indexOf(insp.status) === 4 || Object.keys(inspectionStatus).indexOf(insp.status) === 5 || this.props.userRole === 'agent') ?
                        <Button compact basic circular  ><span className='format-capitalize'> {inspectionStatus[insp.status]}</span></Button> :<StatusUpdateForm mobileView={true} currentStatus={insp["status"]} statusDateChange= {() => {this.handleStatusChangeDate(insp['inspection_start_time'])}} inspectionDate={insp['inspection_start_time']} inspectionId={insp.id} userRole={this.props.userRole}
                                                       startDate={this.state.fromDate} endDate={this.state.toDate}/>}

                </div>
        </div></Card.Meta>
      </Card.Content>
      <Card.Content extra>
        <div className='ui two buttons'>
          <Button onClick={()=>this.handleView(insp.id)} basic icon color='green'>
            View <Icon name="eye"></Icon>
          </Button>
          {this.props.userRole !== 'agent' ? <Button icon color='orange' basic
                            disabled={!(insp['user'] && insp['user']['name'])|| insp.status == "cancelled" || insp.status =="aborted"}
                            as="a"
                            target="_blank"
                            onClick={() => {this.handleReport(insp['report_id'], insp['status'], insp)} }
                            > Report <Icon
                        name='arrow right'/></Button>:<Button basic  icon color='orange' 
                                                    disabled={!(insp['user'] && insp['user']['name'] && insp['status'] === 'completed')}
                                                    as="a"
                                                    target="_blank"
                                                   onClick={() => {this.handleReport(insp['report_id'], insp['status'], insp)} }
                            > Report <Icon
                            name='arrow right'/></Button>
                        }
        </div>
      </Card.Content>
    </Card>})}</Card.Group>
                    </Segment>}
                   {!this.state.isMobile && <ReactTable
                        data={!this.state.dateFiltered ? this.props.inspectionData.inspections : this.props.inspectionDataByDate.inspections}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        defaultPageSize={100}
                        defaultSorted={[{
                            id: 'inspection_time',
                            desc: false,
                        }, {
                            id: 'user',
                            desc: false
                        }]}
                        defaultFiltered={[{
                            id: 'status',
                            value: this.props.filterStatus ? this.props.filterStatus : ""
                        }]}
                        minRows={12}
                        style={{
                            height: '620px'
                        }}
                        noDataText="No Inspections Found in Selected range"
                        pageSizeOptions={[5, 10, 20, 25, 50, 100,200,500]}
                    />}</React.Fragment>}
                <Modal size={this.state.action !== "customer_service" ? "large" : "fullscreen"} open={this.state.action !== "listing"} closeOnDimmerClick={false} onClose={(e) => {
                        this.setState({action: "listing"})
                    }}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                    this.setState({action: "listing"})
                                }}><Icon name="close"/></Button>
                            </div>
                            <Modal.Description>
                                {this.state.action === 'view' &&
                                <ViewInspectionDetails selectedObject={this.props.selectedObject[0]}
                                                       inspectionId={this.props.selectedObject[0]['id']}
                                                       handleEdit={this.handleEdit}
                                                       currentUserRole={this.props.userRole}/>}
                                {this.state.action === 'update' &&
                                <UpdateInspection selectedObject={this.props.selectedObject[0]}
                                                  userRole={this.props.userRole}/>}
                                {this.state.action === 'create' && <CreateInspection/>}
                                {this.state.action === 'assign' && <AssignClerk date={this.state.selectedInspectionDate}
                                                                                startTime={this.state.startTime}
                                                                                endTime={this.state.endTime}
                                                                                inspectionId={this.state.inspectionId}
                                                                                currentAssignedUser={this.state.currentAssignedUser}
                                                                                companyId={this.state.companyId}/>}

                                {this.state.action === 'assign_viewonly' && <AssignClerk date={this.state.fromDate? this.state.fromDate : moment().format("YYYY-MM-DD")}
                                viewOnly={true}/>}
                            {/* {this.state.action === "offer" && <OffersList inspection_id={this.state.inspectionId}></OffersList>} */}
                            {this.state.action === "customer_service" && <CustomerServiceList  original={this.state.original}
                            handleDownload={()=>this.handleDownload(this.state.original["report_id"], this.state.original)}
                            userRole={this.props.userRole} propertyAddress={ this.state.CSPropertyAddress }inspectionId={this.state.inspectionId} reportId={this.state.reportId}></CustomerServiceList>}  
                            {this.state.action === "agent_edit" && <div>
                            <div><Header
                                content="Change Inspection Date"/><Form> <Form.Group inline><Form.Field><span><b>Date:</b><DayPickerInput
                                dayPickerProps={{
                                    disabledDays: {before: moment().add(4,"days").toDate()},
                                    todayButton: 'Today',
                                    firstDayOfWeek : 1,
                                }}
                                format="DD-MM-YYYY"
                                value={moment().add(4,"days").format("DD-MM-YYYY")}
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={day => {day ? this.setState({agtChangeDate: day,
                                agtChangeTime:moment(day).hour(parseInt(moment(this.state.agtChangeTime).format("HH"))).minute(parseInt(moment(this.state.agtChangeTime).format("mm"))).format("YYYY-MM-DD HH:mm"),}): this.setState({agtChangeDate:undefined})}}/></span>
                           </Form.Field>
                       <span><b>Time:</b>
                       {this.state.anytime == "custom" && 
                                                <TimePicker
                                                    showSecond={false}
                                                    placeholder='08:00'
                                                    value={moment(this.state.agtChangeTime)}
                                                    className="time-width"
                                                    onChange={this.onStartChange}
                                                    format={timeFormat}
                                                    disabledHours={this.disabledHours}
                                                    hideDisabledOptions={true}
                                                    minuteStep={15}
                                                    inputReadOnly
                                                />}
                                                <Button onClick={(e)=>{e.preventDefault();this.setState({anytime:"any"})}}positive={this.state.anytime == "any"}>Anytime</Button>
                                                <Button onClick={(e)=>{e.preventDefault();this.setState({anytime:"am"})}}positive={this.state.anytime == "am"}>Anytime AM</Button>
                                                <Button onClick={(e)=>{e.preventDefault();this.setState({anytime:"pm"})}}positive={this.state.anytime == "pm"}>Anytime PM</Button>
                                                <Button onClick={(e)=>{e.preventDefault();this.setState({anytime:"custom"})}}positive={this.state.anytime == "custom"}>Custom</Button>
                                                </span>
                                              
                                            </Form.Group>
                                          
                                          <Form.TextArea label="Notes" required onChange={e =>{this.setState({agtEditNotes:e.target.value})}}></Form.TextArea>
                           <span><strong>Please explain in as much detail as possible the reason for the change</strong></span><br/>
                           <span><strong>Note: To change dates earlier than 4 days from now, please contact Bookings</strong></span></Form></div>
                            <br/>
                            <div style={{width: '100%'}} className="right-aligned"><Button
                                content="Change Date" primary
                                loading={this.state.agtEditLoading}
                                disabled={!this.state.anytime || !this.state.agtChangeDate || this.state.agtEditNotes.length == 0 || this.state.agtEditLoading}
                                onClick={() => this.handleEditDate(this.state.inspectionId)}/></div>
                                {this.state.agtLoadError && <Message negative>There was an error when attempting to change the date, please contact bookings@hinchpm.com with your request.</Message>}
        
                    </div>}
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>
                </div>
                {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
            </div>
        );
    }

}

export default FilterAttributes(InspectionContainer(ListingContainer(Inspection)));


// WEBPACK FOOTER //
// ./src/views/inspection/index.js